// extracted by mini-css-extract-plugin
export default {"container":"style_container__AXwip","button":"style_button__rIo9P","big":"style_big__GgbLV"};